
import { rzContainer, rzDottedLoader } from '@razlet/ui';

export default {
  components: {
    rzContainer, 
    rzDottedLoader,
  },
};
